<script>
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwSelect from '../generic/forms/tw-select.vue'
import { ADDRESS_COUNTRIES, ADDRESS_REGIONS_BY_COUNTRY_CODE } from '@/generated/addressRegions.js'

export default {
  name: 'AddressEditCard',
  components: { TwSelect, TwInput },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        address_street: null,
        address_city: null,
        address_state: null,
        address_zip: null,
        address_country: null,
      })
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isSyncingFromParent: false,
      Address: {
        ...this.modelValue
      }
    }
  },
  computed: {
    regionsAvailable() {
      return ADDRESS_REGIONS_BY_COUNTRY_CODE[this.Address.address_country] || []
    },
    countriesAvailable() {
      return ADDRESS_COUNTRIES
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (this.areAddressesEqual(newVal, this.Address)) {
          return;
        }

        this.isSyncingFromParent = true;
        this.Address = { ...newVal };
        this.$nextTick(() => {
          this.isSyncingFromParent = false;
        });
      },
      deep: true
    },
    'Address.address_country'(newVal, oldVal) {
      if (this.isSyncingFromParent || newVal === oldVal) return

      this.Address.address_state = null
      this.Address.address_zip = null
    },
    Address: {
      handler(newVal) {
        if (this.isSyncingFromParent || this.areAddressesEqual(newVal, this.modelValue)) {
          return;
        }

        this.$emit('update:modelValue', { ...newVal });
      },
      deep: true
    }
  },
  methods: {
    areAddressesEqual(a = {}, b = {}) {
      return (
        a.address_street === b.address_street &&
        a.address_city === b.address_city &&
        a.address_state === b.address_state &&
        a.address_zip === b.address_zip &&
        a.address_country === b.address_country
      );
    }
  }
}
</script>

<template>
  <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mb-2">
    <tw-select v-model="Address.address_country" label-key="label" value-key="value" :options="countriesAvailable" required label="Country" />
    <tw-select v-model="Address.address_state" label-key="label" value-key="value" :options="regionsAvailable" required label="State / Province / Region" />
  </div>
  <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mb-2">
    <tw-input v-model="Address.address_street" required label="Address" />
    <tw-input v-model="Address.address_city" required label="City" />
  </div>
  <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mb-2">
    <tw-input v-model="Address.address_zip" required label="Zip / Postal Code" />
  </div>
</template>

<style scoped>

</style>
